import styled from 'styled-components';
import media from '../../../constants/media';

export const Wrapper = styled.div`
	margin: 3rem 0;

	${media.tablet`
		margin: 6rem 0;
	`};

	${media.desktopSmall`
		margin: 15rem 0;
	`};
`;

export const ContentWrapper = styled.div`
	max-width: 67.6rem;
`;

export const IconBoxWrapper = styled.div`
	margin-bottom: 3rem;

	${media.desktopSmall`
		margin-bottom: 4rem;
	`};
`;
